import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../document.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentInvoiceDescriptions } from '../document-invoice-descriptions';
import { Message } from 'primeng/api';
import { MenuItem } from "primeng/api";
import { SpinnerService } from '../../core';

@Component({
  selector: 'app-invoice-descriptions-edit',
  templateUrl: './invoice-descriptions-edit.component.html',
  styleUrls: ['./invoice-descriptions-edit.component.css']
})
export class InvoiceDescriptionsEditComponent implements OnInit {
  redError = 'red';
  name_Error = 'none';
  commission_Error = 'none';
  id: number;
  printer: DocumentInvoiceDescriptions;
  msgs: Message[] = [];
  public items: MenuItem[];

  constructor(aroute: ActivatedRoute, 
    private router: Router, 
    private docService: DocumentService,
    private spinnerService: SpinnerService) {
    aroute.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    // Load queue (if editing)
    if (this.id) {
      this.loadPrinter();
    } else {
      this.printer = new DocumentInvoiceDescriptions();
    }
    this.items = [
      {
        label: 'Settings',
        icon: 'fa-gear',
        routerLink: [ '/settings' ],
        routerLinkActiveOptions: { exact: true }
      },
      {
        label: '|'
      },
      {
        label: 'Create Printer',
        icon: 'fa-print',
        routerLink: [ '/settings/invoice-descriptions/create' ],
        routerLinkActiveOptions: { exact: true }
      }
    ];
  }

  loadPrinter() {
    this.docService.getInvoiceDescription(this.id).subscribe((res) => {
      this.printer = res;
      this.spinnerService.hide();
    });
  }

  subcontractnumberconv(event: any) {
    var regex = /^\d*\.?\d{0,2}$/g;
    var num = regex.exec(event.target.value);
    event.target.value = num;
  }

  savePrinter() {
    if(this.printer.name == '' || this.printer.name == null || this.printer.commission == undefined || this.printer.commission == null){
      if(this.printer.name == '' || this.printer.name == null){
        this.name_Error = 'block';
      }else{
        this.name_Error = 'none';
      }
      if(this.printer.commission == undefined || this.printer.commission == null){
        this.commission_Error = 'block';
      }else{
        this.commission_Error = 'none';
      }
      return;
    }
    this.name_Error = 'none';
    this.commission_Error = 'none';

    if (!this.id) {
      this.docService.createInvoiceDescription(this.printer).subscribe((res) => {
        // Display message for 2 seconds
        if(res.output == '1'){
          this.msgs.push({severity: 'success', summary: 'Invoice Description Created', detail: res.message});
        }else{
          this.msgs.push({severity: 'error', summary: 'Message', detail: res.message});
          this.spinnerService.hide();
        }
        setTimeout(() => {
          this.msgs = [];
          if(res.output == '1'){
            this.router.navigate(['settings/invoice-descriptions']);
          }
        }, 2000);
      });
    } else {
      this.docService.saveInvoiceDescription(this.id, this.printer).subscribe(res => {
        // Display message for 2 seconds
        if(res.output == '1'){
          this.msgs.push({severity: 'success', summary: 'Invoice Description Updated', detail: res.message});
        }else{
          this.msgs.push({severity: 'error', summary: 'Message', detail: res.message});
          this.spinnerService.hide();
        }
        setTimeout(() => {
          this.msgs = [];
          if(res.output == '1'){
            this.router.navigate(['settings/invoice-descriptions']);
          }
        }, 2000);
      });
    }
  }

}
